(() => {
  if (window.FrilloraPdpPayments) {
    window.FrilloraPdpPayments.init(document);
    return;
  }

  const instances = new Map();
  const selector = '[data-fr-pdp-payments]';

  const fit = row => {
    const list = row.querySelector('.fr-pdp-payments__list');
    if (!list) return;
    const items = Array.from(list.querySelectorAll('[data-payment-type]'));
    for (const item of items) item.hidden = false;
    const style = getComputedStyle(list);
    const available = list.clientWidth - (parseFloat(style.paddingLeft) || 0) - (parseFloat(style.paddingRight) || 0);
    const gap = parseFloat(style.columnGap) || 0;
    let used = 0;
    let count = 0;
    let overflowed = false;
    for (const item of items) {
      const width = item.getBoundingClientRect().width;
      const required = width + (count ? gap : 0);
      const visible = !overflowed && width > 0 && used + required <= available;
      item.hidden = !visible;
      if (visible) {
        used += required;
        count += 1;
      } else {
        overflowed = true;
      }
    }
    row.dataset.visiblePaymentCount = String(count);
  };

  const schedule = row => {
    const state = instances.get(row);
    if (!state || state.frame) return;
    state.frame = requestAnimationFrame(() => {
      state.frame = 0;
      if (row.isConnected) fit(row);
    });
  };

  const init = root => {
    const rows = Array.from(root.querySelectorAll(selector));
    if (root.matches?.(selector)) rows.unshift(root);
    for (const row of rows) {
      if (instances.has(row)) {
        schedule(row);
        continue;
      }
      const observer = 'ResizeObserver' in window ? new ResizeObserver(() => schedule(row)) : null;
      instances.set(row, { observer, frame: 0 });
      observer?.observe(row);
      fit(row);
    }
  };

  const remove = root => {
    for (const [row, state] of instances) {
      if (row === root || root.contains(row) || !row.isConnected) {
        state.observer?.disconnect();
        if (state.frame) cancelAnimationFrame(state.frame);
        instances.delete(row);
      }
    }
  };

  window.FrilloraPdpPayments = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => remove(event.target));
  if (!('ResizeObserver' in window)) window.addEventListener('resize', () => instances.forEach((state, row) => schedule(row)), { passive: true });
})();
